<script setup>
  import { ref } from "vue";
  import OrderAlf from "./OrderAlf.vue";
  import OrderType from "./OrderType.vue";
  import ButtonEvent from "./ButtonEvent.vue";

  const props = defineProps({
    sortFilters: {
      type: Object,
      default: null,
    },
    orderType: {
      type:Array,
      default: [],
    }
  });

  const emit = defineEmits(['update:sortOrder']);
  const localSortFilters = ref(props.sortFilters);

  const emitActiveSortOrder = (value, type) => {
    emit('update:sortOrder', { value, type });
  };
</script>

<template>
  <div class="filters-container">
    <div class="order-alf-wrapper">
      <order-alf
        :sorts="localSortFilters.name"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'name')"
      ></order-alf>
    </div>

    <div class="order-most-project">
      <button-event
        buttonText="Most Recent"
        buttonType="sort"
        :sorts="localSortFilters.mostRecent"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'mostRecent')">
      </button-event>
    </div>

    <div class="order-series-wrapper">
      <order-type
        :sorts="orderType"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'type')"
      ></order-type>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>
